module.exports = __webpack_public_path__ + "img/img_index_scene_jiaoxue@2x.9e2cf9c1.png";